import { render, staticRenderFns } from "./adTitle.vue?vue&type=template&id=10c2f538&scoped=true"
import script from "./adTitle.vue?vue&type=script&lang=js"
export * from "./adTitle.vue?vue&type=script&lang=js"
import style0 from "./adTitle.vue?vue&type=style&index=0&id=10c2f538&prod&lang=scss&scoped=true"
import style1 from "./adTitle.vue?vue&type=style&index=1&id=10c2f538&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c2f538",
  null
  
)

export default component.exports